export default __webpack_public_path__ + "static/media/pictogramBeaconCategories48.522ee77d.svg";